// const prod = {
//     url: {
//         API_URL: 'https://calculuscircus.com'
//     }
// };

// const dev = {
//     url: {
//         API_URL: 'http://localhost:5001'
//     }
// };

// export const config = process.env.NODE_ENV === 'development' ? dev : prod;

export const config = {
    url: {
        API_URL: process.env.REACT_APP_API_URL
    }
};


